"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M21.5 17.526V6.474c0-1.09-.933-1.974-2.083-1.974H3.583c-1.15 0-2.083.884-2.083 1.974v11.052c0 1.09.933 1.974 2.083 1.974h15.834c1.15 0 2.083-.884 2.083-1.974zM2.333 12c0-.655.559-1.184 1.25-1.184.692 0 1.25.529 1.25 1.184 0 .655-.558 1.184-1.25 1.184-.691 0-1.25-.529-1.25-1.184zm3.334 5.921V6.08H19v11.84H5.667z" }), "ResolutionMediumLandscape");
//# sourceMappingURL=ResolutionMediumLandscape.js.map